import { useTeamQuery } from "../graphql/queries.generated"
import { TeamModel } from "../types/TeamModel"

export function useTeamData({
  teamID
}: {
  teamID: string | null | undefined
}): TeamModel {
  const { data, loading } = useTeamQuery({
    variables: { id: teamID ?? "" },
    skip: !teamID
  })

  return {
    team: data?.team || null,
    isLoading: loading,
    isUpdating: !!data && loading
  }
}
